import Link from "@/components/Link";

type ViewLinkProps = {
  to: string;
};

const ViewLink = ({ to }: ViewLinkProps) => (
  <Link
    type="button"
    to={to}
    className="bg-primary text-white hover:bg-primary/80 focus-visible:outline-primary disabled:bg-primary/60"
  >
    View
  </Link>
);

export default ViewLink;
